  const langTag = process.env.LANG_TAG;
  const isFrance = langTag === "fr-FR"
  
  const getLocalisedContent = (contents) => {
    let localisedContent = contents.filter((content) => {
      if (isFrance) {
        return content.node_locale === "fr"
      } else {
        return content.node_locale !== "fr"
      }
    })

    return localisedContent
  }

module.exports = {
  getLocalisedContent,
}
